/* Ezy Deanz Club — add to cart behaviour (the only new JS) */
(function () {
  "use strict";

  var data = document.getElementById("club-atc-data");
  if (!data) return;

  var variantId = data.dataset.variantId;
  var sellingPlanId = data.dataset.sellingPlanId;
  var addUrl = data.dataset.cartAddUrl || "/cart/add.js";
  var cartUrl = data.dataset.cartUrl || "/cart";
  var cartJsUrl = data.dataset.cartJsUrl || "/cart.js";
  var afterAdd = data.dataset.afterAdd || "checkout";

  var busy = false;

  function setError(btn, message) {
    var holder = btn.parentNode;
    var el = holder.querySelector(".club-atc-error");
    if (!message) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement("p");
      el.className = "club-atc-error";
      el.setAttribute("role", "alert");
      holder.appendChild(el);
    }
    el.textContent = message;
  }

  function setLoading(btn, on) {
    btn.classList.toggle("is-loading", on);
    btn.disabled = on;
    btn.setAttribute("aria-busy", on ? "true" : "false");
  }

  function goToCheckout() {
    window.location.href = afterAdd === "cart" ? cartUrl : "/checkout";
  }

  function getCart() {
    return fetch(cartJsUrl, {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).then(function (res) {
      if (!res.ok) throw new Error("Could not read cart.");
      return res.json();
    });
  }

  /* One order per person: anything already in the cart blocks a second add.
     To restrict this to the membership only, swap the body for:
     return cartHasVariant(cart); */
  function cartIsLocked(cart) {
    return !!cart && Number(cart.item_count) > 0;
  }

  function cartHasVariant(cart) {
    if (!cart || !cart.items) return false;
    var wanted = Number(variantId);
    return cart.items.some(function (item) {
      return Number(item.id) === wanted || Number(item.variant_id) === wanted;
    });
  }

  function addToCart(btn) {
    if (busy) return;

    if (!variantId) {
      setError(btn, "This membership is not available right now.");
      return;
    }

    busy = true;
    setError(btn, "");
    setLoading(btn, true);

    var payload = { id: Number(variantId), quantity: 1 };
    if (sellingPlanId) payload.selling_plan = Number(sellingPlanId);

    getCart()
      .catch(function () {
        return null; // cart read failed, fall through and try the add
      })
      .then(function (cart) {
        if (cartIsLocked(cart)) {
          goToCheckout();
          return null;
        }

        return fetch(addUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        }).then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart.");
            return body;
          });
        });
      })
      .then(function (added) {
        if (!added) return; // already redirecting

        if (typeof window.trackEvent === "function") {
          window.trackEvent("club_add_to_cart", {
            variantId: variantId,
            sellingPlanId: sellingPlanId || null
          });
        }
        goToCheckout();
      })
      .catch(function (err) {
        /* Shopify rejects the add when a quantity or subscription limit is hit.
           If something is in the cart anyway, send them through instead of erroring. */
        return getCart()
          .then(function (cart) {
            if (cartIsLocked(cart)) {
              goToCheckout();
              return;
            }
            throw err;
          })
          .catch(function () {
            busy = false;
            setLoading(btn, false);
            setError(btn, err.message || "Something went wrong. Please try again.");
          });
      });
  }

  document.addEventListener("click", function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== "function") return;
    var btn = target.closest("[data-club-atc]");
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });
})();